var _metadata, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagnesconnectUnset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1007.8127 157.55164",
    height: 157.55164,
    width: 1007.8127,
    id: "svg1233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata1239"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1237"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,-162.76036,745.44216)",
    id: "g1241"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 530.6162,516.6528 c 5.407,0 10.557,-2.047 14.129,-5.615 l 0.779,-0.78 4.844,4.689 -0.821,0.803 c -5.119,5.013 -11.843,7.774 -18.931,7.774 -15.737,0 -26.729,-10.897 -26.729,-26.501 0,-15.356 11.242,-26.5 26.729,-26.5 7.19,0 13.916,2.764 18.938,7.782 l 0.792,0.791 -4.91,4.906 -0.792,-0.791 c -3.7,-3.696 -8.813,-5.817 -14.028,-5.817 -9.78,0 -19.648,6.069 -19.648,19.629 0,13.56 9.868,19.63 19.648,19.63",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 582.4883,477.6172 c -11.225,0 -19.062,7.925 -19.062,19.26 0,11.501 8.013,19.856 19.062,19.856 11.037,0 19.062,-8.355 19.062,-19.856 0,-11.335 -7.848,-19.26 -19.062,-19.26 m 0,45.893 c -15.088,0 -26.037,-11.203 -26.037,-26.633 0,-15.442 10.706,-26.236 26.037,-26.236 15.32,0 26.037,10.794 26.037,26.236 0,15.43 -10.96,26.633 -26.037,26.633",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 665.5684,499.7485 c 0,-0.773 0.058,-1.597 -0.021,-2.359 l 0.021,-26.867 h -7.187 l -0.003,28.424 c 0,0.224 -0.134,2.924 -0.359,3.999 -0.549,3.216 -1.859,5.848 -3.898,7.865 -0.347,0.347 -0.717,0.66 -1.098,0.974 -0.011,0 -0.022,0.011 -0.022,0.011 -2.957,2.7 -6.868,4.347 -11.18,4.347 -9.141,0 -16.369,-7.28 -16.369,-16.421 0,-0.762 0,-1.559 -0.02,-2.354 l -0.008,-26.845 h -7.21 l 0.038,26.89 c -0.08,0.75 -0.08,3.808 0,4.559 0.548,5.78 3.158,10.967 7.101,14.776 4.291,4.156 10.127,6.71 16.558,6.71 6.363,0 12.143,-2.498 16.4,-6.576 4.537,-4.324 7.257,-10.378 7.257,-17.133",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 723.5684,499.7485 c 0,-0.773 0.058,-1.597 -0.021,-2.359 l 0.021,-26.867 h -7.187 l -0.003,28.424 c 0,0.224 -0.134,2.924 -0.359,3.999 -0.549,3.216 -1.859,5.848 -3.898,7.865 -0.347,0.347 -0.717,0.66 -1.098,0.974 -0.011,0 -0.022,0.011 -0.022,0.011 -2.957,2.7 -6.868,4.347 -11.18,4.347 -9.141,0 -16.369,-7.28 -16.369,-16.421 0,-0.762 0,-1.559 -0.02,-2.354 l -0.008,-26.845 h -7.21 l 0.038,26.89 c -0.08,0.75 -0.08,3.808 0,4.559 0.548,5.78 3.158,10.967 7.101,14.776 4.291,4.156 10.127,6.71 16.558,6.71 6.363,0 12.143,-2.498 16.4,-6.576 4.537,-4.324 7.257,-10.378 7.257,-17.133",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 738.9131,500.0654 c 1.419,10.062 8.843,16.733 18.805,16.733 11.303,0 18.262,-6.228 18.805,-16.733 z m 38.475,15.614 c -4.566,5.042 -11.558,7.823 -19.67,7.823 -14.905,0 -26.141,-11.414 -26.141,-26.54 0,-15.569 10.749,-26.44 26.141,-26.44 8.987,0 17.465,3.801 22.119,9.907 l 0.653,0.865 -5.219,4.177 -0.687,-0.909 c -3.657,-4.831 -11.303,-7.036 -16.866,-7.036 -8.388,0 -17.286,4.976 -18.816,16.034 h 44.148 l 0.099,0.997 c 0.854,8.711 -1.13,16.024 -5.761,21.122",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 818.0479,516.6309 c 5.399,0 10.541,-2.046 14.107,-5.612 l 0.78,-0.779 4.835,4.686 -0.82,0.803 c -5.111,5.01 -11.825,7.77 -18.902,7.77 -15.714,0 -26.688,-10.892 -26.688,-26.487 0,-15.348 11.223,-26.486 26.688,-26.486 7.18,0 13.896,2.762 18.91,7.777 l 0.791,0.791 -4.903,4.903 -0.791,-0.791 c -3.694,-3.694 -8.8,-5.813 -14.007,-5.813 -9.766,0 -19.618,6.066 -19.618,19.619 0,13.552 9.852,19.619 19.618,19.619",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 875.3398,479.7422 -1.057,-0.508 c -2.56,-1.228 -5.109,-1.905 -7.177,-1.905 -6.737,0 -8.054,3.804 -8.054,10.373 l 0.006,29.457 h 16.909 l 0.017,6.378 h -16.943 l 0.011,14.908 -7.08,-0.738 0.012,-14.17 h -10.636 l 0.034,-6.378 h 10.585 l 0.005,-29.457 c 0,-11.541 4.951,-17.15 15.134,-17.15 2.978,0 6.205,0.86 9.864,2.631 l 0.96,0.465 z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1283"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    id: "g2160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1287",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 190.7856,477.3613 c 0,-2.24 0,-4.492 0.011,-6.766 h 16.176 v 14.597 h -16.198 c 0,-2.565 0.011,-5.165 0.011,-7.831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1291",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 156.2822,485.1924 c 0,-2.477 0.011,-4.963 0.011,-7.528 0.011,-2.33 0.011,-4.672 0.011,-7.035 h 16.244 c 0.011,2.117 0.011,4.211 0.011,6.295 0.011,2.812 0.022,5.557 0.011,8.268 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1295",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 122.2271,480.2744 c 0.067,-3.148 0.146,-6.396 0.157,-9.635 h 15.571 c 0.011,2.207 0.011,4.404 0.011,6.576 0,2.711 0.011,5.355 0.011,7.977 h -15.851 c 0.034,-1.625 0.067,-3.261 0.101,-4.918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1303",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 144.4614,523.4102 c 0.269,0 0.526,0.011 0.784,0.011 v -15.436 c -4.156,-0.863 -7.293,-4.56 -7.293,-8.962 0,-0.259 0.011,-0.594 0.056,-0.953 -0.089,-1.276 -0.078,-2.598 -0.067,-3.887 0.011,-1.669 0.022,-3.327 0.022,-4.996 h -15.884 c -0.045,5.041 0.067,9.97 0.549,14.91 0.997,10.127 10.798,18.798 21.833,19.313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1307",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 167.4487,519.8032 c 3.047,1.49 6.418,3.137 12.166,3.596 v -15.459 c -4.067,-0.93 -7.103,-4.582 -7.103,-8.917 0,-0.28 0.011,-0.572 0.045,-0.863 -0.067,-1.065 -0.056,-2.095 -0.045,-2.924 v -0.201 c 0.022,-1.949 0.045,-3.899 0.045,-5.848 h -16.266 c 0,2.106 0.012,4.223 0.023,6.34 0.011,1.031 -0.011,1.949 -0.09,2.79 0.022,0.236 0.034,0.47 0.034,0.706 0,4.257 -2.935,7.852 -6.89,8.861 v 15.481 c 6.767,-0.325 9.265,-1.792 11.684,-3.249 0.874,-0.526 1.793,-1.063 2.868,-1.534 l 0.459,-0.191 0.46,0.191 c 0.873,0.369 1.714,0.784 2.61,1.221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1311",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 206.9702,496.7822 v -7.595 h -16.187 c 0,2.241 0.011,4.481 0.033,6.733 0.011,0.739 -0.011,1.466 -0.067,2.173 0.034,0.28 0.056,0.571 0.056,0.93 0,4.323 -3.024,7.965 -7.068,8.905 v 15.594 h 0.19 l 0.415,-0.022 c 11.493,-0.684 20.937,-9.937 22.449,-21.979 0.19,-1.546 0.179,-3.093 0.179,-4.739"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 385.8833,498.1943 v -27.673 h -13.42 v 27.572 c 0,7.864 -5.746,12.34 -11.763,12.256 -4.279,-0.06 -7.584,-1.703 -9.713,-5.176 -0.1,-0.134 -0.179,-0.269 -0.257,-0.403 -0.045,-0.078 -0.101,-0.168 -0.146,-0.246 -0.862,-1.457 -1.411,-3.115 -1.557,-4.896 -0.011,-0.022 -0.011,-0.034 -0.011,-0.045 -0.09,-0.683 -0.134,-1.377 -0.134,-2.095 v -26.967 h -13.32 v 29.163 c 0.437,8.671 5.276,16.187 12.322,20.366 3.753,2.218 8.134,3.455 12.805,3.495 7.402,0.063 11.386,-1.491 14.184,-3.099 6.848,-3.938 11.01,-11.92 11.01,-22.252",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 407.0762,503.21 c 1.822,5.377 6.504,8.437 12.975,8.437 6.758,0 11.12,-3.06 12.069,-8.437 z m 31.869,12.887 c -4.395,4.836 -11.076,7.387 -19.291,7.387 -15.913,0 -26.591,-10.524 -26.591,-26.193 0,-16.465 10.523,-26.69 27.485,-26.69 8.414,0 16.641,3.114 21.467,8.128 l 0.375,0.386 -8.536,8.425 -0.386,-0.397 c -2.761,-2.861 -8.624,-4.407 -12.722,-4.407 -7.608,0 -12.886,3.556 -13.968,9.331 h 38.119 l 0.044,0.509 c 0.939,10.049 -1.126,18.187 -5.996,23.521",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 474.8096,503.3096 c -5.787,0.367 -8.6,1.937 -8.6,4.8 0,2.737 3.05,4.305 8.367,4.305 5.01,0 8.621,-1.298 11.71,-4.21 l 0.421,-0.396 7.463,8.778 -0.407,0.359 c -5.325,4.671 -10.941,6.576 -19.386,6.576 -10.531,0 -21.158,-4.889 -21.158,-15.808 0,-12.308 12.982,-15.125 20.731,-15.709 7.653,-0.436 9.191,-2.084 9.191,-4.602 0,-1.084 -0.466,-2.114 -1.346,-2.975 -1.523,-1.491 -4.183,-2.398 -6.912,-2.32 -5.141,0.094 -12.975,2.789 -16.444,6.654 l -0.466,0.52 -6.596,-9.565 0.311,-0.324 c 7.519,-7.831 15.839,-8.887 22.987,-8.887 14.889,0 21.554,8.337 21.554,16.601 0,13.136 -11.447,15.559 -21.42,16.203",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1323"
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    id: "g2165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1327",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 321.4487,477.6279 c -3.215,-3.08 -7.158,-5.399 -11.539,-6.665 2.443,-1.523 4.123,-3.943 4.123,-7.304 0,-6.15 -4.728,-10.127 -12.042,-10.127 -7.092,0 -12.446,4.347 -12.446,10.127 v 0.56 h -13.32 v -0.56 c 0,-13.386 10.598,-22.741 25.766,-22.741 15.235,0 25.462,9.142 25.462,22.741 0,4.032 -0.716,9.511 -6.004,13.969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1331",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 325.9536,525.5947 -1.372,1.152 c -1.903,1.598 -2.15,4.436 -0.551,6.34 l 20.483,24.389 c 1.599,1.903 4.437,2.15 6.34,0.552 l 1.371,-1.152 c 1.904,-1.598 2.151,-4.437 0.553,-6.34 l -20.484,-24.389 c -1.598,-1.904 -4.437,-2.151 -6.34,-0.552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.33333325
    },
    d: "m 424.74805,630.10547 -6.81836,8.85156 c -4.61371,-2.35875 -9.82645,-3.67383 -15.35157,-3.67383 -18.73066,0 -33.91992,15.17692 -33.91992,33.90625 0,18.73067 15.18926,33.90625 33.91992,33.90625 18.73067,0 33.90625,-15.17558 33.90626,-33.90625 0,-7.78266 -2.61383,-14.95187 -7.03516,-20.67187 -5.6e-4,-7.3e-4 -0.001,-10e-4 -0.002,-0.002 l 7.15039,-9.2832 z m -22.16993,21.36914 c 9.784,0 17.71485,7.93084 17.71485,17.71484 0,9.784 -7.93085,17.71485 -17.71485,17.71485 -9.79866,0 -17.72851,-7.93085 -17.72851,-17.71485 0,-9.784 7.92985,-17.71484 17.72851,-17.71484 z",
    transform: "matrix(0.75000002,0,0,-0.75000002,0,1000)",
    id: "path1335"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1345",
    transform: "matrix(0.75000002,0,0,-0.75000002,0,1000)",
    d: "m 325.05078,635.2832 c -19.46133,0 -35.24023,15.77795 -35.24023,35.22461 0,19.46 15.7789,35.23828 35.24023,35.23828 7.20702,0 13.88854,-2.16392 19.45703,-5.86914 v 6.09375 h 15.76758 v -70.6875 h -15.76758 v 5.86524 c -5.5685,-3.70777 -12.25,-5.86524 -19.45703,-5.86524 z m 0,15.86719 c 10.69333,0 19.3711,8.66409 19.3711,19.35742 0,10.70667 -8.67777,19.37305 -19.3711,19.37305 -10.69333,0 -19.37305,-8.66638 -19.37305,-19.37305 0,-10.69333 8.67972,-19.35742 19.37305,-19.35742 z",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.33333325
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnesconnectUnset);
export default __webpack_public_path__ + "static/media/magnesconnect-unset.4593be47.svg";
export { ForwardRef as ReactComponent };